import global from "../global"

/**
 * 请求
 *
 * @type {{post(*, *): Promise<any>, upload(*, *): Promise<void>, get(*): Promise<*>}}
 * @author winixi@qq.com
 */
const request = {
  /**
   * get
   *
   * @param apiUri
   * @param isString
   * @param isConfigApiServer
   * @returns {Promise<any>}
   */
  async get(apiUri: string, isString: boolean = false, isConfigApiServer: boolean = true): Promise<any> {
    let options: RequestInit = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Session-Key": global.getSessionKey(),
      } as HeadersInit,
    }
    let ApiServer: string = ""
    if (isConfigApiServer) ApiServer = global.getApiServer()
    let res: Response = await fetch(ApiServer + apiUri, options)
    if (isString) return res.text()
    return res.json()
  },

  /**
   * post
   *
   * @param apiUri
   * @param data
   * @param isString
   * @param isConfigApiServer
   */
  async post(apiUri: string, data: object, isString: boolean = false, isConfigApiServer: boolean = true): Promise<any> {
    let options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Session-Key": global.getSessionKey(),
      } as HeadersInit,
      body: JSON.stringify(data),
    }
    let ApiServer: string = ""
    if (isConfigApiServer) ApiServer = global.getApiServer()
    let response: Response = await fetch(ApiServer + apiUri, options)
    if (isString) return response.text()
    return response.json()
  },

  /**
   * 修改
   *
   * @param apiUri
   * @param data
   * @param isString
   * @param isConfigApiServer
   */
  async put(apiUri: string, data: object, isString: boolean = false, isConfigApiServer: boolean = true): Promise<any> {
    let options = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "Session-Key": global.getSessionKey(),
      } as HeadersInit,
      body: JSON.stringify(data),
    }
    let ApiServer: string = ""
    if (isConfigApiServer) ApiServer = global.getApiServer()
    let response: Response = await fetch(ApiServer + apiUri, options)
    if (isString) return response.text()
    return response.json()
  },

  /**
   * 删除
   * @param apiUri
   * @param data
   * @param isString
   * @param isConfigApiServer
   */
  async delete(apiUri: string, isString: boolean = false, isConfigApiServer: boolean = true): Promise<any> {
    let options = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "Session-Key": global.getSessionKey(),
      } as HeadersInit,
    }
    let ApiServer: string = ""
    if (isConfigApiServer) ApiServer = global.getApiServer()
    let response: Response = await fetch(ApiServer + apiUri, options)
    if (isString) return response.text()
    return response.json()
  },

  /**
   * 上传文件
   *
   * @param apiUri
   * @param file
   * @param fileType
   * @param fileKey
   * @returns {Promise<void>}
   */
  async upload(apiUri: string, file: File, fileType:string, fileKey:string): Promise<any> {
    let formData: FormData = new FormData()
    formData.append("file", file)
    formData.append("fileType", fileType)
    formData.append("fileKey", fileKey)
    let options = {
      method: "POST",
      headers: {
        // 'Content-Type': 'multipart/form-data;charset=utf-8',
        "Session-Key": global.getSessionKey(),
      } as HeadersInit,
      body: formData,
    }
    let response: Response = await fetch(global.getApiServer() + apiUri, options)
    return response.json()
  },

  /**
   * 下载文件
   *
   * @param apiUri
   * @param data
   * @param fileName
   * @param isConfigApiServer
   */
  async download(apiUri: string, data: object, fileName: string = 'download.xlsx', isConfigApiServer: boolean = true): Promise<void> {
    let options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Session-Key": global.getSessionKey(),
      } as HeadersInit,
      body: JSON.stringify(data),
    }
    let ApiServer: string = ""
    if (isConfigApiServer) ApiServer = global.getApiServer()
    
    try {
      let response: Response = await fetch(ApiServer + apiUri, options)
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      
      // 获取文件blob
      const blob = await response.blob()
      
      // 创建下载链接
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      
      // 尝试从响应头获取文件名
      const contentDisposition = response.headers.get('Content-Disposition')
      if (contentDisposition && contentDisposition.includes('filename=')) {
        const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
        if (fileNameMatch && fileNameMatch[1]) {
          fileName = fileNameMatch[1].replace(/['"]/g, '')
        }
      }
      
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Download failed:', error)
      throw error
    }
  },
}

export default request
